import request from "@/utils/request";

export const queryUserLogPromise = (p) => request({
  url: "/admin/log/user",
  method: "get",
  params: p
});

export const querySmsLogPromise = (p) => request({
  url: "/admin/log/sms",
  method: "get",
  params: p
});
